<section class="funfact-one login">
  <div id="myModal" class="modal fade registerConfirm">
    <div class="modal-dialog modal-confirm">
      <div class="modal-content">
        <div class="modal-header justify-content-center">
          <div class="icon-box">
            <i class="fas fa-check"></i>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body text-center">
          <h4 translate>¡Cuenta Creada Satisfactoriamente!</h4>
          <p translate>Tenga en cuenta que podrá iniciar sesión en el panel de afiliados tan pronto como nuestros moderadores activen su cuenta</p>

        </div>
      </div>
    </div>
  </div>
  <img src="/assets/images/shapes/testi-shape-1-1.png" class="testimonials-one__background-image" alt="Awesome Image" />
<div class="row justify-content-center">
  <div class="modal-content col-lg-6 col-md-12">


      <div class="modal-header text-center">
        <h4 class="modal-title w-100 font-weight-bold" translate>Registrate</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    <form [formGroup]="registerForm" class="registerForm">
      <div class="modal-body mx-3">
        <div *ngIf="showError" class="alert alert-danger">
                    <div *ngIf="response.AlertMessage != ''" translate>{{response.AlertMessage | translate}}</div>
                  <div *ngIf="response.error.email != ''" translate>{{response.error.email | translate}}</div>
                </div>
        <div class="form-row">
          <div class="col mb-4">
            <i class="fas fa-user prefix grey-text login-icon"></i>
            <input type="text" id="defaultForm-name" class="form-control validate" formControlName="name" required>
            <label data-error="wrong" data-success="right" for="defaultForm-name" translate>Nombres</label>
            <div *ngIf="registerForm.controls['name'].invalid && (registerForm.controls['name'].dirty || registerForm.controls['name'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['name'].errors.required" translate>Nombres es requerido.</div>
                </div>
          </div>
          <div class="col mb-4">
            <i class="fas fa-user prefix grey-text login-icon"></i>
            <input type="text" id="defaultForm-lastname" class="form-control validate" formControlName="lastname" required>
            <label data-error="wrong" data-success="right" for="defaultForm-lastname" translate>Apellidos</label>
            <div *ngIf="registerForm.controls['lastname'].invalid && (registerForm.controls['lastname'].dirty || registerForm.controls['lastname'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['lastname'].errors.required" translate>Apellidos es requerido.</div>
                </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col mb-4">
            <i class="fas fa-phone prefix grey-text login-icon"></i>
            <input type="text" id="defaultForm-phone" class="form-control validate" formControlName="phone" required>
            <label data-error="wrong" data-success="right" for="defaultForm-phone" translate>Telefono</label>
            <div *ngIf="registerForm.controls['phone'].invalid && (registerForm.controls['phone'].dirty || registerForm.controls['phone'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['phone'].errors.required" translate>Telefono es requerido.</div>
                </div>
          </div>
          <div class="col mb-4">
            <i class="fas fa-envelope prefix grey-text login-icon"></i>
            <input type="email" id="defaultForm-email" class="form-control validate" formControlName="email" required>
            <label data-error="wrong" data-success="right" for="defaultForm-email" translate>Correo electronico</label>
            <div *ngIf="registerForm.controls['email'].invalid && (registerForm.controls['email'].dirty || registerForm.controls['email'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['email'].errors.required" translate>Correo electronico es requerido.</div>
                </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col mb-4">
            <i class="fas fa-lock prefix grey-text login-icon"></i>
            <input type="password" id="defaultForm-pass" class="form-control validate" formControlName="password" [(ngModel)] = "model.password" required>
            <label data-error="wrong" data-success="right" for="defaultForm-pass" translate>Contraseña</label>
            <div *ngIf="registerForm.controls['password'].invalid && (registerForm.controls['password'].dirty || registerForm.controls['password'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['password'].errors.required" translate>Contraseña es requerido.</div>
                  <div *ngIf="registerForm.controls['password'].errors.minlength" translate>Contraseña debe tener minimo 6 digitos.</div>
                </div>
          </div>
          <div class="col mb-4">
            <i class="fas fa-lock prefix grey-text login-icon"></i>
            <input type="password" id="defaultForm-passconfirm" class="form-control validate" formControlName="passconfirm" [(ngModel)] = "model.passconfirm" required>
            <label data-error="wrong" data-success="right" for="defaultForm-passconfirm" translate>Confirmar Contraseña</label>
            <div *ngIf="registerForm.controls['passconfirm'].invalid && (registerForm.controls['passconfirm'].dirty || registerForm.controls['passconfirm'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['passconfirm'].errors.required" translate>Confirmar contraseña es requerido.</div>
                </div>
                <div *ngIf="(model.password != model.passconfirm) && registerForm.controls['passconfirm'].touched" class="alert alert-danger">
                    <div translate>Las contraseñas ingresadas no coinciden.</div>
                </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col mb-4">
            <i class="fas fa-coins prefix grey-text login-icon"></i>
            <select name="selectCurrency" id="defaultForm-currency" class="form-control validate" formControlName="currency" required>
              <option *ngFor="let currency of currencys" [ngValue]="currency.name" translate>{{currency.name}}</option>
            </select>
            <label data-error="wrong" data-success="right" for="defaultForm-currency" translate>Moneda</label>
            <div *ngIf="registerForm.controls['currency'].invalid && (registerForm.controls['currency'].dirty || registerForm.controls['currency'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['currency'].errors.required" translate>Moneda es requerido.</div>
                </div>
          </div>
          <div *ngIf="config.partner != 18" class="col mb-4">
            <i class="fab fa-chrome prefix grey-text login-icon"></i>
            <input type="text" id="defaultForm-site" class="form-control validate" formControlName="site">
            <label data-error="wrong" data-success="right" for="defaultForm-site" translate>Sitio Web</label>
            <div *ngIf="registerForm.controls['site'].invalid && (registerForm.controls['site'].dirty || registerForm.controls['site'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['site'].errors.required" translate>Sitio Web es requerido.</div>
                </div>
          </div>
        </div>
        <div class="form-row">
          <div *ngIf="config.partner != 18 && config.partner != 13" class="col mb-4">
            <i class="fab fa-skype prefix grey-text login-icon"></i>
            <input type="text" id="defaultForm-skype" class="form-control validate" formControlName="skype">
            <label data-error="wrong" data-success="right" for="defaultForm-skype" translate>Skype</label>
            <div *ngIf="registerForm.controls['skype'].invalid && (registerForm.controls['skype'].dirty || registerForm.controls['skype'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['skype'].errors.required" translate>Skype es requerido.</div>
                </div>
          </div>
          <div class="col mb-4">
            <i class="fa fa-globe-americas prefix grey-text login-icon"></i>
            <select name="selectCountry" id="defaultForm-countryf" class="form-control validate" formControlName="countryf" required>
              <option *ngFor="let country of countries" [ngValue]="country.Id" translate>{{country.Name}}</option>
            </select>
            <label data-error="wrong" data-success="right" for="defaultForm-countryf" translate>País</label>
            <div *ngIf="registerForm.controls['countryf'].invalid && (registerForm.controls['countryf'].dirty || registerForm.controls['countryf'].touched)" class="alert alert-danger">
                    <div *ngIf="registerForm.controls['countryf'].errors.required" translate>País es requerido.</div>
                </div>
          </div>
        </div>
      </div>
    </form>
      <div class="modal-footer d-flex justify-content-center">
        <button class="btn btn-default register-btn" (click)="register()" [disabled]="registerForm.invalid" translate>Registrarme</button>
      </div>
    </div>
  </div>
</section><!-- /.funfact-one -->
